/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs */

const en_shortcut_keys_desc_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decrease start time by one frame`)
};

const fr_shortcut_keys_desc_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diminuer le temps de debut d'une image`)
};

const de_shortcut_keys_desc_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verringere die Startzeit um ein Frame`)
};

const it_shortcut_keys_desc_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riduci l'ora di inizio di un fotogramma`)
};

const ru_shortcut_keys_desc_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уменьшите время начала на один кадр.`)
};

const es_shortcut_keys_desc_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disminuir el tiempo de inicio en un cuadro`)
};

const zh_cn2_shortcut_keys_desc_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`减少一帧的起始时间`)
};

const ja_shortcut_keys_desc_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始時間を1フレーム減らす`)
};

const hi_shortcut_keys_desc_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारंभ समय को एक फ्रेम से घटाएँ`)
};

const pt_pt2_shortcut_keys_desc_subtract_frame_from_start = /** @type {(inputs: Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diminua o tempo de início em um quadro.`)
};

/**
* | output |
* | --- |
* | "Decrease start time by one frame" |
*
* @param {Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_subtract_frame_from_start = /** @type {((inputs?: Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Subtract_Frame_From_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_subtract_frame_from_start(inputs)
	if (locale === "de") return de_shortcut_keys_desc_subtract_frame_from_start(inputs)
	if (locale === "it") return it_shortcut_keys_desc_subtract_frame_from_start(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_subtract_frame_from_start(inputs)
	if (locale === "es") return es_shortcut_keys_desc_subtract_frame_from_start(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_subtract_frame_from_start(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_subtract_frame_from_start(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_subtract_frame_from_start(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_subtract_frame_from_start(inputs)
	return en_shortcut_keys_desc_subtract_frame_from_start(inputs)
});